import { css } from '@emotion/css';
import {
  desktopSideNavWidthPx,
  extraLargeDesktopWidth,
  ZIndex,
} from '@snapchat/snap-design-system-marketing';

import { richTextCtaClassName } from '../../utils/contentfulComponentMap';
import { totalHeaderHeightCssVar } from '../Header/headerSizeUtils';

/**
 * Used to ensure consistent rendering of page since some of our breaks have different widths and
 * cause inconsistent rednering without this.
 */
export const pageContainerCss = css`
  flex-grow: 1;
  max-width: ${extraLargeDesktopWidth}px;
`;

export const pageContainerWithSideNavCss = css`
  max-width: ${extraLargeDesktopWidth - desktopSideNavWidthPx}px;
`;

export const pageStickyCss = css`
  position: sticky;
  top: var(${totalHeaderHeightCssVar});
  z-index: ${ZIndex.SUB_NAVIGATION};
`;

export const bannerContentContainerCss = css`
  line-height: 20px;
  white-space: pre-wrap;

  /* TODO: Swap this rule when use a proper <p> element for paragraphs */
  .sdsm-p {
    margin-bottom: 0;
  }

  .${richTextCtaClassName} {
    font-size: 14px;
    /*
    need to unset lineheight because it messes with alignment :(
    also need vertical align bottom to make it actually aligned for some reason
    */
    line-height: unset;
    vertical-align: bottom;

    /*
    hack because icons mess up alignment due to their taller size and
    we don't want to use flex because the text nodes won't be able to wrap
    properly then
    */
    i {
      font-size: 14px;
      transform: scale(1.25);
    }

    /* same as above for images, bad and will update in future */
    img {
      height: 14px;
      transform: scale(1.5);
      margin-left: 2px;
    }
  }
`;

export const stickyBottomCss = css`
  position: sticky;
  bottom: 0;
  z-index: ${ZIndex.MOBILE_CTA};
`;

export const pageFixedCss = css`
  position: fixed;
  bottom: 0;
  z-index: ${ZIndex.PAGE_FIXED_PORTAL};
`;
